import { render } from "./ShoppingActivityAddEdit.vue?vue&type=template&id=139808e9&scoped=true"
import script from "./ShoppingActivityAddEdit.vue?vue&type=script&lang=js"
export * from "./ShoppingActivityAddEdit.vue?vue&type=script&lang=js"

import "./ShoppingActivityAddEdit.vue?vue&type=style&index=0&id=139808e9&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-139808e9"]])

export default __exports__